<template>
  <div class="news">
      <div id="stage row">
        <p
          id="sharer"
          class="text-center text-white mt-2 mb-2"
          v-if="this.sharerMsg"
        >{{this.sharerMsg}}</p>
        <div class="row">
          <div class="col-12">
            <Asset
              :item="this.item"
              :displayPoster="true"
              v-if="this.item && this.item.isVod"
              :accessToken="this.accessToken"
              :isExpanded="true"
              :isShared="this.sharerMsg !== null"
              class="card-share"
            />
          </div>
        </div>
        <keep-alive>
          <More :id="catId" :sharedItem="item" v-show="catId" :isDisplayed="isDisplayed"/>
        </keep-alive>
      </div>
  </div>
</template>

<script>
import Asset from '../views/Asset'
import More from '../components/More'
import { mapActions } from 'vuex'
import { spinnakerApi } from '../js/SpinnakerApi.js'

export default {
  name: 'News',
  props: ['catId', 'isDisplayed'],
  components: {
    Asset,
    More
  },
  data: function () {
    return {
      accessToken: undefined,
      sharerMsg: null,
      item: null
    }
  },
  created: async function () {
    if (this.$route.query.token && Object.keys(this.$route.query).length === 1) {
      this.item = await spinnakerApi.fetchData(this.$route.query.token)
    } else if (this.$route.query.progId) {
      this.item = await spinnakerApi.getProgrammeDetailsWithMapping(
        this.$route.query.progId
      )
    } else {
      this.item = {}
    }
    this.$store.commit('share/setMetadata', this.item)
  },
  mounted: function () {
    console.info('Landing page beforeMount')
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'share/setMetadata':
          this.sharerMsg = state.share.sharerMsg
          break
      }
    })
  },
  methods: {
    ...mapActions('share', ['getMetadata'])
  }
}
</script>

<style scoped></style>
